import { Routes } from '@angular/router';

import { ClaimsGuard } from '../../auth/guard/claims.guard';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

export const GRAPHS_ROUTES: Routes = [
  {
    path: 'inspections',
    canActivate: [ClaimsGuard],
    data: {
      claims: [getClaimString(AppFeature.GraphsInspections, AppActions.Read)],
    },
    loadComponent: () =>
      import(
        './components/graphs-inspections.component/graphs-inspections.component'
      ).then(m => m.GraphsInspectionsComponent),
  },
];
